

















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { BaseHeading, UCIcon } from '@shared/ui';

import { SocialMediaLink } from '../types';

export default defineComponent({
  name: 'AppFooterMenuItemSocialMedia',
  components: { UCIcon, BaseHeading },
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array as PropType<SocialMediaLink[]>,
      default: () => [],
    },
  },
});
